export function detectDeviceType() {
  if (typeof navigator === "undefined") return "desktop";
  const ua = navigator.userAgent || "";
  const platform = navigator.platform || "";
  if (/ipad|tablet/i.test(ua) || /iPad/.test(platform)) return "tablet";
  if (/mobile|iphone|android/i.test(ua)) return "mobile";
  return "desktop";
}

export function readGeoForActivity() {
  try {
    const countryCode = (localStorage.getItem("visitorCountryCode") || "").trim().toUpperCase();
    const countryName = (localStorage.getItem("visitorCountry") || "").trim();
    return {
      countryCode: /^[A-Z]{2}$/.test(countryCode) ? countryCode : undefined,
      countryName: countryName || undefined,
    };
  } catch {
    return {};
  }
}
